const getSchedulerMetadata = () => {
    return new Promise((resolve, reject) => {
        SellsyJS.WebServiceCaller.get(`/rest/scheduler/setup/metadata`,
            {},
            res => resolve(res),
            err => reject(err.response.data.error.message)
        );
    })
};

const getSchedulerConfiguration = () => {
    return new Promise((resolve, reject) => {
        SellsyJS.WebServiceCaller.get(`/rest/scheduler/configuration`,
            {},
            res => resolve(res),
            err => reject(err.response.data.error.message)
        );
    })
};

const validScopeOffice = () => {
    return new Promise((resolve, reject) => {
        SellsyJS.WebServiceCaller.post('/rest/scheduler/setup/active-existing-account',
            {},
            {},
            res => resolve(res),
            err => reject(err.response.data.error.message)
        );
    });
}

export {
    getSchedulerMetadata, 
    getSchedulerConfiguration,
    validScopeOffice
}